import en from "./en.js";
import ru from "./ru.js";
import it from "./ita.js";

let lang = localStorage.getItem("language")
  ? localStorage.getItem("language")
  : "en";

export const locale = {
  locale: lang,
  fallback: "en",
  globalInjection: true,
  messages: { en, ru, it },
};
